import {Component, ViewChild} from '@angular/core';
import {Events, IonicPage, NavController, NavParams, Platform, Refresher, ViewController} from 'ionic-angular';
import {ShopPage} from "../shop/shop";
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";
import {TeamServiceProvider} from "../../providers/team-service/team-service";
import { ShopNewPage } from '../shop-new/shop-new';

@IonicPage()
@Component({
  selector: 'page-shop-listing',
  templateUrl: 'shop-listing.html',
})
export class ShopListingPage {

  errors: {};
  loading: boolean;
  shops: any;
  shopId: any;

  @ViewChild(Refresher) refresher: Refresher;

  constructor(
    public platform: Platform,
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public events: Events,
    private http: HttpClient,
    public teamProvider: TeamServiceProvider,
    private apiErrorHandler: ApiErrorHandlerProvider,
  ) {
    this.shopId = navParams.get('shopId') ? navParams.get('shopId') : null;
    this.shops = navParams.get('shops') ? navParams.get('shops') : null;

    if (!this.shopId && localStorage.getItem('webShopId')) {
      this.shopId = localStorage.getItem('webShopId');
    }
  }

  ionViewWillEnter() {
    this.viewCtrl.showBackButton(false);
  }

  ionViewDidLoad() {
    if (this.shops) {
      this.getShopQueueTime(this.shops);
    } else {
      this.loading = true;
      this.getShops().then(() => {
        this.loading = false;
      })
    }

    if (this.teamProvider.isCustomApp()) {
      this.teamProvider.getShopLocationIds().then((shopIds: any) => {
        // Only send the team member to the shop page if their current team id is one of the shop locations
        let currentTeamId = localStorage.getItem('currentTeamId');
        if (currentTeamId && parseInt(currentTeamId) > 0) {
          if (shopIds.includes(parseInt(currentTeamId))){
            this.navCtrl.push(ShopNewPage, {shopId: currentTeamId});
            // this.navCtrl.push(ShopPage, {shopId: currentTeamId});
            return;
          }
        }

        // Send customer to the last shop they booked but only if the last booking id is one of the shop locations
        let lastBookingTeamId = localStorage.getItem('lastBookingTeamId');
        if (lastBookingTeamId && parseInt(lastBookingTeamId) > 0) {
          if (shopIds.includes(parseInt(lastBookingTeamId))){
            this.navCtrl.push(ShopNewPage, {shopId: lastBookingTeamId});
            // this.navCtrl.push(ShopPage, {shopId: lastBookingTeamId});
            return;
          }
        }

      });
    }

  }

  getShops() {
    return new Promise((resolve, reject) => {
        this.teamProvider.getShopLocations(this.shopId).then((shops) => {
          this.shops = shops;
          this.getShopQueueTime(this.shops);
          this.loading = false;
          return resolve();
        })
    });
  }

  getShopQueueTime(shops) {
    // Iterate over each shop and make an api request to get the current queue time
    shops.forEach(shop => {
      this.http.get(`/teams/${shop.id}/queue`)
        .subscribe((response: any) => {
          shop.queue = response;
        });
    });

  }

  openPage(event: any, shop: object) {
    this.navCtrl.push(ShopPage, {
      shop: shop
    });
  }

  pullToRefresh() {
    this.getShops().then(() => {
      this.refresher.complete();
    }).catch(() => {
      this.refresher.complete();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/shop-listing/shop-listing.ts